<template>
  <div class="game-tr-step">
    <div
      :id="'step_' + stepData.index"
      class="stepp-button"
      :style="[setConfig(), config.cssStyle]"
      @click="setModalStatus(true)"
    >
      {{ stepData.id }}
    </div>
    <transition name="img-fade">
      <div class="game-tr-step-modal" v-if="modalStatus" @click="setModalStatus(false)">
        <div class="game-tr-step-modal-content" :style="setModalWidth()">
          <div class="close-button-container comics-stepp" slot="modal-header-close">
            <button type="close" name="close" @click="close" class="close-button" style="margin-top: 7px">
              <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
                <path
                  data-v-bd40240e=""
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  fill="rgb(230, 230, 230)"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </button>
          </div>
          <div class="title-container" :style="setModalStyle(stepData.title)" v-html="stepData.title.text"></div>
          <div
            class="image-container"
            v-if="stepData.header"
            :style="getImageStyle(stepData.header && stepData.header.imageData)"
          >
            <img
              style="object-fit: scale-down"
              :src="giveMeImagePlease(stepData.header.imageData.imagePath)"
              :style="getImageStyle(stepData.header && stepData.header.imageData)"
            />
          </div>
          <div
            class="text-container"
            v-if="stepData.textObj"
            :style="setModalStyle(stepData.textObj)"
            v-html="stepData.textObj.text"
          ></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../../Utils/inputUtils';
export default {
  name: 'tr-comics',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    stepData: {
      type: null,
      default: function () {
        return {};
      },
    },
    showStep: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      modalStatus: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    setModalWidth() {
      if (this.stepData.header.imageData) {
        return { width: this.stepData.header.imageData.width + 60 + 'px' };
      }
    },
    setModalStatus(status) {
      this.modalStatus = status;
    },
    showModal(index) {
      this.show = !this.show;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({}, this.getCustomStyle(imageData), {
        // 'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    setModalStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    setConfig() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        'font-size': this.config.fontSize + 'px',
        background: this.config.backgroundColor,
        color: this.config.color,
      };
    },
    getStyle(item) {
      item.width = item.width;
      item.height = item.height;
      return _.merge(this.getCustomStyle(item), {
        width: utils.elementWidth(item.width, 'px'),
        height: utils.elementHeight(item.height, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    close($event) {
      this.show = !this.show;
      this.$emit('close-modal', $event);
    },
  },
  computed: {
    show: {
      get() {
        return this.showStep.show;
      },
      set(newValue) {
        this.showStep.show = newValue;
      },
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';

.game-tr-step {
  .stepp-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    font-size: 29px;
    background: #f26f21;
    color: #fff;
    font-family: $gameFontFamily;
    font-weight: bold;
  }
}
</style>
<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
$aplaColor: #dde1ea;
.popover {
  .popover-body {
    font-size: 25px;
    font-family: $gameFontFamily;
    padding: 0;
    background-color: #f5f5dc;
    .popover-body-step-text {
      padding: 0.5rem 0.75rem;
      background-color: #f5f5dc;
    }
  }
}
.comics-stepp-close {
  pointer-events: auto;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1;
  z-index: 1252;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: $closeActiveColor;
  margin-right: 12px;
  margin-top: 22px;
  border-radius: 50%;
  display: flex;
  transform: scale(1);
  padding: 0;

  &:hover {
    svg {
      path:first-child {
        fill: $closeActiveColor;
        transition: all 0.4s ease;
      }
    }
    background-color: $backgroundControlPanelColor;
    transition: all 0.4s ease;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.game-step-by-step-wrapper {
  .modal {
    z-index: 1050;
    .modal-header {
      z-index: 1060;
      padding: 34px;
      .close-button-container {
        z-index: 1060;
      }
    }
  }
  .modal-content {
    width: 1800px;
    height: 980px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    left: -514px;
    background-color: $aplaColor;
    .image-container {
      position: relative;
      display: flex;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .title-container {
      text-align: left;
      font-weight: bold;
    }
    .text-container {
      text-align: justify;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);

      .close-button {
        pointer-events: auto;
        opacity: 0;
        transition: opacity 4s ease;
      }
    }
  }
}
</style>
<style lang="sass" scoped>
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
.game-tr-step-modal
  width: 1920px
  height: 1080px
  top: 0
  left: 0
  z-index: 1400
  background: rgba(0,0,0, .5)
  position: fixed
  display: flex
  align-items: center
  justify-content: center
  .game-tr-step-modal-content
    max-width: 80%
    max-height: 1080px
    position: absolute
    overflow-y: auto
    overflow-x: hidden
    background-color: #ffffff
    padding: 30px
    border-radius: 2rem
    .title-container
      border-bottom: #b8b8b8 1px solid
      max-height: 100px
      width: 100%
      text-align: left
      font-weight: bold
      font-size: 24px
    .image-container
      margin-top: 30px
      margin-bottom: 10px
      position: relative
      display: flex
      display: block
      width: 100%
      height: 100%
      background-size: contain
      background-repeat: no-repeat
    .text-container
      text-align: justify
      font-size: 24px

  .close-button
    pointer-events: auto
    position: absolute
    top: 0
    right: 0
    opacity: 1
    z-index: 1003
    cursor: pointer
    outline: none
    border: none
    background-color: $backgroundControlPanelColor
    margin-right: 12px
    margin-top: 22px
    border-radius: 50%
    display: flex
    transform: scale(1)
    padding: 0
    svg
      path:first-child
        fill: $bacgroundColor
        transition: all 0.4s ease
    &:hover
      svg
        path:first-child
          fill: $closeActiveColor
          transition: all 0.4s ease
      transition: all 0.4s ease
    img
      width: 100%
      height: 100%

.img-fade-leave-active, .img-fade-enter-active
  transition: all .3s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
</style>
